import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
/**
 * This context is intended to allow information about the current, active
 * layout to be shared across various components at different levels of the tree.
 *
 * Generally speaking a single `<AppLayoutContext.Provider />` should be used
 * per page. More complex scenarios, however, might necessitate using multiple.
 */

export var AppLayoutContext = React.createContext({
  appLayoutVariant: 'hcenter',
  currentHeaderHeight: 0,
  setHeaderHeight: function setHeaderHeight() {}
});
/**
 * A default, stateful wrapper that makes it easy to set the current layout.
 *
 * Most of the time you should use this.
 */

export var DefaultAppLayoutProvider = function DefaultAppLayoutProvider(_ref) {
  var appLayoutVariant = _ref.appLayoutVariant,
      children = _ref.children;

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentHeaderHeight = _React$useState2[0],
      setHeaderHeight = _React$useState2[1];

  return /*#__PURE__*/React.createElement(AppLayoutContext.Provider, {
    value: {
      appLayoutVariant: appLayoutVariant,
      currentHeaderHeight: currentHeaderHeight,
      setHeaderHeight: setHeaderHeight
    }
  }, children);
};